var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDigitalIconOrange = function SvgDigitalIconOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    transform: "translate(-92.000000, -323.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Digital",
    transform: "translate(92.000000, 323.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Digital",
    transform: "translate(2.000000, 2.000000)",
    fill: "#EE9800",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,1 L6.6,1 C5.16405965,1 4,2.15126779 4,3.57142857 L4,16.4285714 C4,17.8487322 5.16405965,19 6.6,19 L14.4,19 C15.8359403,19 17,17.8487322 17,16.4285714 L17,3.57142857 C17,2.15126779 15.8359403,1 14.4,1 Z M15.7,16.4285714 C15.7,17.1386518 15.1179702,17.7142857 14.4,17.7142857 L6.6,17.7142857 C5.88202983,17.7142857 5.3,17.1386518 5.3,16.4285714 L5.3,3.57142857 C5.3,2.86134818 5.88202983,2.28571429 6.6,2.28571429 L14.4,2.28571429 C15.1179702,2.28571429 15.7,2.86134818 15.7,3.57142857 L15.7,16.4285714 Z M11.8,15.1428571 C11.8,15.8529375 11.2179702,16.4285714 10.5,16.4285714 C9.78202983,16.4285714 9.2,15.8529375 9.2,15.1428571 C9.2,14.4327768 9.78202983,13.8571429 10.5,13.8571429 C11.2179702,13.8571429 11.8,14.4327768 11.8,15.1428571 Z",
    id: "Shape"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDigitalIconOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/digital-icon-orange.edd3f28e.svg";
export { ForwardRef as ReactComponent };